import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
var getProductJsonLD = getJsonLD(TYPES.PRODUCT);
export default {
  name: 'ProductJsonLD',
  props: {
    product: {
      type: Object,
      required: true
    },
    url: {
      type: String,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    scriptJsonLD: function scriptJsonLD() {
      var product = _objectSpread({}, this.product, {
        url: this.url,
        currency: this.locale.currency
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getProductJsonLD(product)),
        body: true
      };
    }
  }),
  head: function head() {
    return {
      script: [this.scriptJsonLD]
    };
  },
  render: function render(h) {
    return h(null);
  }
};